import classes from "./Language.module.css"
import React from "react"
import { useTranslation } from "react-i18next"

const Language = props => {
    const { t, i18n } = useTranslation()

    const onSetLanguage = lang => i18n.changeLanguage(lang.target.value)

    const nativeLanguages = {
        en: "English (EU)",
        es: "espa\u00f1ol (Espa\u00f1a)",
        fr: "fran\u00e7ais (France)",
        de: "Deutsch",
        it: "Italiano",
        nl: "Nederlands",
        ru: "Русский",
        "en-US": "English (NA)",
        "es-MX": "espa\u00f1ol (Latinoam\u00e9rica)",
        "fr-US": "fran\u00e7ais (Canada)",
        jp: "\u65e5\u672c\u8a9e",
        kr: "\ud55c\uad6d\uc5b4",
        "zh-CN": "\u7b80\u4f53\u4e2d\u6587",
        "zh-TW": "\u7e41\u9ad4\u4e2d\u6587",
        "pt-BR": "Portuguese (Brazil)",
    }

    const possibleLang = i18n.languages.filter(lang => lang in nativeLanguages)[0]
    let currentLang
    if (possibleLang === undefined) {
        currentLang = "en"
    } else {
        currentLang = possibleLang
    }

    return (
        <>
            <div className={classes.cardWrapperWrapper}>
                <div className={classes.cardWrapper}>
                    <div className={classes.Subtitle}>
                        <h6 className={classes.Subtitleh6}>{t("misc:Common.Language")}</h6>
                    </div>
                    <hr className={classes.Divider} />
                    <div className={classes.CardContent}>
                        <div className={classes.CardDark}>
                            <div>
                                <div style={{ marginTop: 16 }}>
                                    <select className={classes.Select} onChange={onSetLanguage} value={currentLang}>
                                        {Object.entries(nativeLanguages).map(([key, val]) => {
                                            return (
                                                <option key={key} value={key}>
                                                    {val}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <h3>{t("other:Cmn_OptionTop.L_StaffCredit-T_Text")}</h3>
                                    <ul>
                                        <li>
                                            {"espa\u00f1ol (Espa\u00f1a)"}:{" "}
                                            <a href="https://twitter.com/spl_bridg3tt">Bridg3tt</a>
                                        </li>
                                        <li>
                                            {"fran\u00e7ais (France)"}:{" "}
                                            <a href="https://twitter.com/Tarsmio">Tarsmio</a>
                                        </li>
                                        <li>
                                            {"Italiano"}: <a href="https://twitter.com/SOgekuri">Francesco Rolando</a>
                                        </li>
                                        <li>
                                            {"espa\u00f1ol (Latinoam\u00e9rica)"}:{" "}
                                            <a href="https://twitter.com/CharizardTweet">Luis Cl</a>
                                        </li>
                                        <li>
                                            {"\u65e5\u672c\u8a9e"}:{" "}
                                            <a href="https://twitter.com/ikatimes1">イカタイムズ</a> &{" "}
                                            <a href="https://github.com/niyari">niyari</a>
                                        </li>
                                        <li>
                                            {"\u7b80\u4f53\u4e2d\u6587"}:{" "}
                                            <a href="https://twitter.com/gellneko216">Gell</a> &{" "}
                                            <a href="https://twitter.com/CKC_Ray">レイ</a> &{" "}
                                            <a href="https://github.com/PMisRIGHT">Lwww</a>
                                        </li>
                                        <li>
                                            {"\u7e41\u9ad4\u4e2d\u6587"}: <a href="https://twitter.com/CKC_Ray">レイ</a>
                                        </li>
                                        <li>
                                            {"Nederlands"}: <a href="https://twitter.com/FoguAlt">Fogu</a>
                                        </li>
                                        <li>
                                            {"Русский"}: <a href="https://twitter.com/a_bog_hag">yaga</a>
                                        </li>
                                        <li>
                                            {"Portuguese (Brazil)"}: <a href="https://twitter.com/Ant__Spl">Ant</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Language

// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"61228d553e7463c203e05e7810dd79a7"}}}
// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"7d8b560e31617e981cf7c8aa1ca13a00"}}}
// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"d29cd0c2b5e6bac90dd5b817914832f8"}}}
